import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import { API_URL, PHP_API, getUser } from "../../../utils/Common";
import HistorialEstados from "../../sharecomponents/HistorialEstados";
import VainillaDialog from "../../sharecomponents/vanilladialog";
import DetallesPlanCosechaEntrada from "../../sharecomponents/DetallesPlanCosechaEntrada";
import AclimatacionEstadoLista from "../../sharecomponents/AclimatacionEstadoLista";
import EntregaEstado from "../../sharecomponents/EntregaEstado";
import Reporte_aclimatacion_consolidacion from "./vivero/components/Reporte_aclimatacion_consolidacion";
import { generarExcel } from "../../sharecomponents/ExcelUtilities";
import { JsonFormatExcel } from "../../../utils/JsonFormatExcel";
import PDF_plan_consolidacion from "../../templates/PDF_plan_consolidacion";
import EntregaPlanPDF from "../../templates/EntregaPlanPDF";
import detalles from '../../../assets/detalles.png';
import vr from "../../../utils/Verifiers";

const RpteSiembraEjecutada = (props) => {
   const [loader, updateLoader] = useState(false);
   const [planes, setPlanes] = useState([]);
   const [dialog, setDialog] = useState({ show: false });
   const [history, setHistory] = useState([]);
   const [paginador, setPaginador] = useState({ estatus: 2, semana: '0', pag: 1, totalR: 0, semana_siembra: false, flor: 0, terminados: false });
   const [semanas, setsemanas] = useState([""]);
   const [paginas, setPaginas] = useState([1]);
   const [totales, settottales] = useState({ total_planeado: 0, total_ejecutado: 0, total_plantar: 0 });
   const [idDetalles, setidDetalles] = useState();
   const [btnGuardar, setbtnGuardar] = useState();
   const [cambiosEnEstado, setcambiosEnEstado] = useState({});
   const [tipo_semana, settipo_semana] = useState({ name: 'Sem. transplante', value: false });
   const [flores_tipos, setflores_tipos] = useState([]);
   const [showHistory, setshowHistory] = useState(false);
   const [checkReport, setcheckReport] = useState('consolidacion');
   const format = new JsonFormatExcel();
   const [show_template, setshow_template] = useState(false);
   const totales_keys = [{ key: 'total_planeado', name: 'PLAN DE SIEMBRA', color: "#C5F3F7" },
   { key: 'total_ejecutado', name: 'EJECUCIÓN DE SIEMBRA', color: "#F8FA65" },
   { key: 'total_aclimatacion', name: 'GERMINACIÓN MONITOREADA', color: "#8EFA65" }];



   useEffect(() => {

      consultarSemana();
   }, []);

   const mostrar_ocultar_detalles = (id) => {
      if (!id || idDetalles == id) setidDetalles(-1);
      else setidDetalles(id);
   }

   //SE ENVIA A LAS SECCIONES DE REPORTE DE ACLIMATACION Y REPORTE DE ENTREGA PARA CONTROLAR CUANDO SE PUED EO NO ENVIAR EL REPORTE
   const activarBoton = (activar, ids) => {
      setbtnGuardar(activar);
      if (!activar) setcambiosEnEstado([]);
      else {
         let user = getUser();
         let nuevos_cambios = [];
         for (let i = 0; i < ids.length; i++)
            if (ids[i].modif != 0)
               nuevos_cambios.push({ plan: planes[i].id, valor: ids[i].modif });

         setcambiosEnEstado({ valoresPlanes: nuevos_cambios, tipoEntrada: (paginador.estatus ?? 0) - 1, usuario: user ? user.id : null });
      }
   }

   const guardarCambiosModif = () => {
      axios.post(`${PHP_API}cambiarEstatusvivero`, cambiosEnEstado).then((resp) => {
         if (resp.data.estatus) {
            setbtnGuardar(false);
            setcambiosEnEstado({});
            consultarSemana();
         }
      });
   }

   const cambiarGermiancion = (value, index, type) => {
      let dataSend = { id: planes[index].id };
      dataSend[type] = value;

      let original = planes[index][type];
      planes[index][type] = value;
      setPlanes([...planes]);
      // -- enviar al servidor
      axios
         .post(PHP_API + "setGerminacion", dataSend)
         .then((r) => {

            if (r.data.estatus) {
               let pl = [...planes];
               pl[index].por_germinacion = r.data.data.por_germinacion;
               pl[index].germinacion_envio = r.data.data.germinacion_envio;
               pl[index].germinacion_real = r.data.data.germinacion_real;
               setPlanes(pl);
            } else {
               let pl = [...planes];
               pl[index][type] = original;
               setPlanes(pl);
            }
         })
         .catch((e) => console.log(e));
   };

   const setEstatus = (e) => {
      let p = paginador;
      setcambiosEnEstado({});
      setbtnGuardar(false);
      p.estatus = e.target.value ?? 0;
      p.terminados = p.estatus > 0 ? false : true;
      setPaginador(p);
      consultarSemana(p);
   }

   const setSemana = (e) => {
      let p = paginador;
      p.semana = e.target.value ?? "0";
      setPaginador(p);
      consultarSemana(p);
   }

   function changePage(back) {
      let p = paginador;
      let totalPages = Math.ceil(paginador.totalR / 50);
      if (back && paginador.pag > 1) {
         p.pag--;
         setPaginador(p);
         consultarSemana(p);
      } else if (!back && paginador.pag < totalPages) {
         p.pag++;
         setPaginador(p);
         consultarSemana(p);
      }
   }

   const jumpPage = (e) => {
      let pagina = e.target.value;
      let p = paginador;
      p.pag = pagina;
      consultarSemana(p);
   }

   const ajustarPagina = (p) => {
      let totalPages = Math.ceil(p.totalR / 50);
      if (p.pag > totalPages) {
         p.pag = 1;
      }
      let pagesT = [];
      for (let i = 1; i <= totalPages; i++)  pagesT.push(i);
      setPaginas(pagesT);

      setPaginador(p);
   }

   const changeValueAnRefresh = (event) => {
      let p = { ...paginador };
      p[event.target.name] = event.target.value;
      setPaginador(p);
      consultarSemana(p);
   }

   const update_check_report = (event) => {
      let rep = event.target.value;
      setcheckReport(rep);
      consultarSemana({ ...paginador }, rep);

   }

   const consultarSemana = (pag, rep) => {
      let urls = {
         0: PHP_API + "aclimatacion",
         2: PHP_API + "aclimatacion",
         3: PHP_API + "aclimatacion",
         4: PHP_API + "plan_aclimatacion"
      };

      let uri = urls[paginador.estatus];
      if (!pag) pag = { ...paginador };
      if (+paginador.estatus === 4) { pag.tipo = rep ? rep : checkReport; }
      updateLoader(true);
      axios
         .post(uri, pag ?? paginador)
         .then((r) => {
            setPlanes([...r.data.planes]);
            setsemanas([...r.data.semanas]);
            setflores_tipos([...r.data.flores]);
            let p = { ...pag };
            p.totalR = r.data.counter;
            ajustarPagina(p);
            settottales({ total_planeado: r.data.total_planeado, total_ejecutado: r.data.total_ejecutado, total_plantar: r.data.total_plantar, total_aclimatacion: r.data.total_aclimatacion ?? 0 })
            updateLoader(false);
         })
         .catch((e) => console.log(e));
   };


   const concluir = async (plan) => {
      setDialog({
         show: true,
         tipo: 'error',
         title: "CONFIRMACIÓN",
         body: "¿Realmente deseas marcar como concuido este registro? si realiza esta accion el registró no estará disponible para ser editado",
         size: 'm',
         respYes: "Si, concluir",
         respNot: "volver",
         funct: (resp) => { if (resp) concluirConfirm(plan); setDialog({ show: false }) }
      });
   }

   const concluirConfirm = async (plan) => {
      updateLoader(true);
      let resp = await axios.post(`${PHP_API}concluirEnvivero`, { user: getUser().id, plan_id: plan }).catch((e) => { updateLoader(false) });
      updateLoader(false);
      if (!resp || !resp.data) return;
      if (!resp.data.estatus) {
         setDialog({
            show: true,
            tipo: 'error',
            title: "OCURRIÓ UN PROBLEMA",
            body: resp.data.msj,
            size: 'm',
            funct: (resp) => { setDialog({ show: false }) }
         });
         return;
      }

      setDialog({
         show: true,
         tipo: 'success',
         title: "TODO BIEN",
         body: resp.data.msj,
         size: 'm',
         funct: (resp) => { setDialog({ show: false }) }
      });
      consultarSemana();
   }
   const mostrarHistorial = (id) => {
      setshowHistory(true);
      abrirHistorial(id);
   }

   const abrirHistorial = (id) => {
      updateLoader(true);
      axios.post(`${PHP_API}HistorialEstatusvivero`, { id: id }).then((resp) => {
         updateLoader(false);
         setHistory([...resp.data]);
         setshowHistory(true);
      }).catch((e) => { updateLoader(false) })

   }

   const separador = () => { return (<span className="ms-2 me-2 text-900" style={{ color: "#BBBBBB" }}>|</span>) }

   const numberFormat = (number) => {
      try {
         let format = parseFloat(number);
         if (isNaN(format)) return 0;
         return Math.floor(format);
      } catch (error) {
         console.log(`Error ` + error, number);
         return 0;
      }
   }

   const showDialog = (title = "", body = "", tipo = "error",) => {
      setDialog({
         show: true,
         tipo: tipo,
         title: title,
         body: body,
         size: 'm',
         funct: () => { setDialog({ show: false }) }
      });
   }

   /**
       * Retorna las diferencias en semanas entre la semana de siembra planeada y la semana de ejecución
       * @param {object} p - un elemento del plan de siembra de la lista alojada en data
       * @returns {number} numero de semanas de diferencia respecto a semana de siembra planeada
       */
   const diferencia = (p) => {
      if (p.semana_ejecucion && p.fecha_inicio) {
         let inicio = new Date(p.fecha_inicio);
         let ejecucion = new Date(p.fecha_semana_ejecucion);

         let diferencia = ejecucion - inicio;
         let dias = diferencia / (1000 * 60 * 60 * 24);
         let semanas = dias / 7;
         return Math.floor(semanas);
      }
      return 0;
   }

   const deshacerSalidaVivero = async (id) => {
      const resp = await vr.getDataAPI(`/api/cierre_vivero/${id}/deshacer`, {}, updateLoader, setDialog);
      if (resp && resp.estatus) {
         consultarSemana();
      }
   }

   return (
      <div className="w-100 h-100 p-1 dosis" style={{ overflow: 'auto' }}>
         <div className="bg-white border rounded shadow-xl">
            <div className="border-b rounded-t p-1 bg-orange-900">
               <div className='row justify-content-start m-0 p-0'>
                  <p className="font-bold uppercase text-white h4"> Aclimacitación y Entrega <span className="text-300 text-s text-white mt-0 mb-0 text-satart ms-4" >Registre la cantidad útil que se consolida y entrega</span></p>
               </div>
            </div>
            <div className='row justify-content-evenly m-0 ps-0 pe-0 pt-1 pb-1 w-100'>

               <div className='col-auto form-group p-1 text-center'>
                  <div className="btn-group" role="group" aria-label="Basic example">
                     <button type="button" className="btn btn-sm btn-dark certus-bg-gradient-black shadow-sm text-white" onClick={() => { changePage(true) }}>❮</button>
                     <select className='form-control form-control-sm text-center ps-1 pe-1 border ml-1 mr-1' value={paginador.pag} onChange={jumpPage}>
                        {
                           (paginas ?? []).map((pag) => {
                              return (
                                 <option value={pag} key={"pagina" + pag}>{pag}</option>
                              )
                           })
                        }
                     </select>
                     <button type="button" className="btn btn-sm btn-dark certus-bg-gradient-black shadow-sm text-white" onClick={() => { changePage(false) }}>❯</button>
                  </div>
               </div>
               <div className='col-auto contenedor text-center m-1'>
                  <select className='form-control form-control-sm text-cente text-bold shadow-sm border border-info' placeholder='' value={paginador.semana} onChange={setSemana}>
                     <option value='0' >{paginador.estatus == 4 ? "SEMANA ACTUAL" : 'TODAS LAS SEMANAS'}</option>
                     {
                        semanas.map((sem) => {
                           return (
                              <option key={sem.semanainicio + "semana"} value={sem.semanainicio} >{sem.semanainicio}</option>
                           )
                        })
                     }
                  </select>
               </div>

               <div className='col-auto contenedor text-center m-1'>
                  <select className='form-control form-control-sm pointer shadow-sm border border-info' name="flor" value={paginador.flor} onChange={changeValueAnRefresh}>
                     <option value='0' >TODAS LAS FLORES</option>
                     {
                        flores_tipos.map((flor, i) => {
                           return (<option key={'tipoflor ' + i} value={flor.id} >{flor.nombre}</option>);
                        })
                     }
                  </select>
               </div>

               {+paginador.estatus !== 4 && <div className='col-auto contenedor text-center text-s m-1'>
                  <p className={`m-0 p-1 ps-2 pe-2 border text-bold round-l text-s border bg-${tipo_semana.value ? 'dark text-white' : 'light text-dark border-dark'} shadow pointer scale-025`} onClick={() => {
                     let vals = { 'Sem. transplante': { name: 'Sem. siembra', value: true }, 'Sem. siembra': { name: 'Sem. transplante', value: false } };
                     settipo_semana(vals[tipo_semana.name]);
                     let pg = { ...paginador };
                     pg.semana = "0";
                     pg.semana_siembra = vals[tipo_semana.name].value;
                     consultarSemana(pg);
                     setPaginador(pg);
                  }}>{tipo_semana.name}</p>
               </div>}

               <div className='col-auto contenedor text-center m-1'>
                  <select className='form-control form-control-sm pointer text-center shadow-sm border border-info' placeholder='' value={paginador.estatus} onChange={setEstatus}>
                     <option value='2' >INVENTARIO DE VIVERO</option>
                     <option value='4' >PROGRAMA DE CONSOLIDACIÓN POR DÍA</option>
                     <option value='3' >ENTREGA</option>
                     <option value='0' >CONCLUIDOS EN VIVERO</option>
                  </select>
               </div>

               {+paginador.estatus !== 4 && <>
                  {
                     totales_keys.map((dt, i) => {
                        return (
                           <div key={"totales" + i} className={`text-center  rounded-lg m-1 col-auto nowrap text-s p-1 contenedor border `} style={{ backgroundColor: dt.color }}>
                              <div className='row justify-content-evenly w-100 m-0 p-0'>
                                 <div className="w-100 m-0 p-0">{dt.name}
                                    <span className="text-s ms-2 text-bold"> {totales[dt.key]} pl</span>
                                 </div>
                              </div>
                           </div>
                        )
                     })
                  }

                  <div className='col-auto text-center m-1'>
                     {btnGuardar && <button className='btn btn-sm degradado_morado text-bold text-white shadow ' onClick={guardarCambiosModif}>Guardar cambios</button>}
                  </div>
               </>}
               {+paginador.estatus === 4 && <>
                  <div className=' contenedor m-1 p-0' style={{ width: '300px' }}>
                     <div className='row justify-content-evenly m-0 p-0 w-100'>
                        <div className='col-auto contenedor text-bold  w-40 m-0 p-0'>Revisión</div>
                        <select className=' w-60 form-control form-control-sm pointer text-center shadow-sm border border-info text-bold' onChange={update_check_report} value={checkReport}>
                           <option value='consolidacion' >Consolidación</option>
                           <option value='aclimatacion' >Aclimatación</option>
                        </select>
                     </div>
                  </div>
                  <div className='col-auto'>
                     <button className='btn btn-dark pt-1 pb-1 scale-05 shadow rounud-xs bg-green4' onClick={() => {
                        if (planes.length === 0) return;
                        generarExcel(checkReport === 'consolidacion' ? format.plan_consolidacion(planes) : format.aclimatacion(planes),
                           checkReport === 'consolidacion' ? 'PLAN_CONSOLIDACION' : "REPORTE_ACLIMATACIÓN")
                     }} >Excel</button>
                  </div>
               </>}
               {[3, 4].includes(+paginador.estatus) && <div className='col-auto'>
                  <button className='btn btn-dark pt-1 pb-1 scale-05 shadow rounud-xs bg-red2' onClick={() => {
                     if (planes.length === 0) return;
                     setshow_template(true);
                  }} >PDF</button>
               </div>}
               {show_template && <div className='vw-100 vh-100 m-0 p-0 bg-white3 blur-xl' style={{ position: "fixed", zIndex: 99, top: 0, left: 0, overflow: 'auto' }}>
                  <div className='row justify-content-evenly p-0 m-0 w-100'>
                     {+paginador.estatus === 4 && <PDF_plan_consolidacion data={planes} type={checkReport} loader={updateLoader} close={() => { setshow_template(false) }} />}
                     {+paginador.estatus === 3 && <EntregaPlanPDF data={planes} loader={updateLoader} close={() => { setshow_template(false) }} />}
                  </div>
               </div>}
            </div>

            {!loader && paginador.estatus == 2 && <AclimatacionEstadoLista data={planes} status={paginador.estatus} save={activarBoton} setPlanes={setPlanes} cambiarGermiancion={cambiarGermiancion} />}
            {!loader && paginador.estatus == 3 && <EntregaEstado data={planes} status={paginador.estatus} save={activarBoton} setPlanes={setPlanes} cambiarGermiancion={cambiarGermiancion} concluir={concluir} />}
            {!loader && paginador.estatus == 4 && <Reporte_aclimatacion_consolidacion data={planes} status={paginador.estatus} setData={setPlanes} type={checkReport} api={consultarSemana} loader={updateLoader} dialog={showDialog} />}
            {!loader && paginador.estatus == 0 && <div className='col-lg-12 p-1 m-0' style={{ overflow: 'auto', maxHeight: '88vh' }}>
               <div className='row justify-content-center m-0 p-0 '>
                  <table className="table table-sm table-hover table-bordered">
                     <thead className="bg-orange-900 text-white">
                        <tr >
                           {/*<th className="text-center nowrap">Acciones</th>*/}
                           <th className="text-center nowrap">Más</th>
                           <th className="text-center nowrap">Flor variedad color</th>
                           <th className="text-center nowrap text-s">Sem. Siembra </th>
                           <th className="text-center nowrap text-s">Sem. Ejecución</th>
                           <th className="text-center nowrap text-s">Sem. Transplante</th>
                           <th className="text-center nowrap p-0 m-0">
                              <div className='col-lg-12 p-0 m-0 text-center'>
                                 <p className="p-0 m-0 text-s">Plan de siembra</p>
                                 <p className="p-0 m-0 text-xs text-bold">Plantas{separador()}Charolas{separador()}Gm. programa</p>
                              </div>
                           </th>
                           <th className="text-center nowrap p-0 m-0">
                              <div className='col-lg-12 p-0 m-0 text-center'>
                                 <p className="p-0 m-0 text-s">Germinación monitoreada</p>
                                 <p className="p-0 m-0 text-xs text-bold">Plantas{separador()}Charolas{separador()}Gm. DDS</p>
                              </div>
                           </th>
                           <th className="text-center nowrap p-0 m-0">
                              <div className='col-lg-12 p-0 m-0 text-center'>
                                 <p className="p-0 m-0 text-s">Entregado a campo</p>
                                 <p className="p-0 m-0 text-xs text-bold">Plantas{separador()}Charolas{separador()}Gm. consolidación</p>
                              </div>
                           </th>

                           <th className="text-center nowrap text-s">Real - Presupuesto</th>
                           <th className="text-center nowrap text-s">Historial</th>
                        </tr>
                     </thead>
                     <tbody>
                        {planes.map((p, i) => {
                           let bgRetrasado = diferencia(p) > 0 ? ' rosa-retrasado border border-white' : '';

                           return (
                              <React.Fragment key={'algo ' + i}>
                                 <tr key={i}>
                                    <td className="text-center contenedor ">
                                       <img src={detalles} className="pointer scale-1" style={{ height: "18px", width: "auto" }}
                                          title="Detalles de la vida de este registro"
                                          onClick={() => { mostrar_ocultar_detalles(p.id) }} />

                                    </td>
                                    <td className={"text-center nowrap text-s" + bgRetrasado} >
                                       <p className={`${p.completo === 1 ? 'text-success' : 'text-floricents'} text-bold`}>{p.bloque}</p>
                                    </td>
                                    <td className="text-center nowrap text-s">{p.semanainicio}</td>
                                    <td className={"text-center nowrap text-s" + bgRetrasado}>{p.semana_ejecucion ?? "-"}</td>
                                    <td className="text-center nowrap text-s">{p.transplante}</td>
                                    <td
                                       className={"border text-center nowrap text-s"}>
                                       {numberFormat(p.plantas)}{separador()}{numberFormat(p.charolas)}{separador()}{p.por_germinacion}%
                                    </td>
                                    <td
                                       className={"border text-center nowrap text-s"}>
                                       {numberFormat(p.total_aclimatacion)}{separador()}{numberFormat(p.charolas_germinadas)}{separador()}{p.germinacion_real}%
                                    </td>
                                    <td
                                       className={"border text-center nowrap text-s"}>
                                       {numberFormat(p.total_entregado)}{separador()}{numberFormat(p.charolas_entregado)}{separador()}{p.germinacion_envio}%
                                    </td>

                                    <td className={`border text-center nowrap text-s  ${numberFormat(p.total_entregado - p.plantas) < 0 ? 'text-red3 text-bold' : ''}`}>
                                       {numberFormat(p.total_entregado - p.plantas)}
                                       <span className="text-xs ms-1">pl</span>
                                    </td>

                                    <td className="nowrap text-xs p-0">
                                       <div className='col-lg-12 m-0 p-1 contenedor bg-white'>
                                          {p.completo === 0 && <button className='btn btn-sm scale-05 btn-dark border border-danger shadow' onClick={() => concluir(p.id)} >Marcar como terminado</button>}
                                          {p.completo === 1 &&
                                             <>
                                                <button className={`btn btn-sm btn-light shadow text-s m-1 `} onClick={() => { mostrarHistorial(p.id); }}>
                                                   <i className="fa fa-history me-1 ms-1" aria-hidden="true"></i>Cambios
                                                </button>
                                                <button className={`btn btn-sm btn-light border border-warning text-bold text-red4 shadow text-s m-1`} onClick={() => { deshacerSalidaVivero(p.id); }}>
                                                   Reingresar
                                                </button>
                                             </>
                                          }
                                       </div>

                                    </td>
                                 </tr>
                                 {idDetalles == p.id && <DetallesPlanCosechaEntrada key={i + "indexEdicion"} data={p} index={i} close={mostrar_ocultar_detalles} span={9} />}
                              </React.Fragment>
                           );
                        })}
                     </tbody>
                  </table>
               </div>
            </div>}
            {showHistory && <HistorialEstados cerrar={() => { setshowHistory(false); setHistory([]); }} data={[...history]} />}
         </div>

         {loader && <div className="frontal-blur-transparent">
            <div className="loader"></div></div>}
         <VainillaDialog data={dialog} />
      </div>
   );
};

export default RpteSiembraEjecutada;
